import React, { useEffect, useRef, useContext, useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import Button from "../../components/button";
import { FontSizeContext } from "../../context/fontSizeContext";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, EffectCoverflow } from "swiper";

SwiperCore.use([Navigation]);
SwiperCore.use([Pagination]);

const LifeAtNeoContainer = ({ mainData, contRef }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);
    return (
        <div className="single-service pt-10 mt-5" ref={contRef}>
            <div className={` ${mainData[0].color}`}>
                {mainData[0].icon ? (
                    <div className="text-center">
                        <img
                            className="radius-box career-logo-width"
                            src={process.env.PUBLIC_URL + mainData[0].icon}
                            alt="images"
                        />
                    </div>
                ) : (
                    ""
                )}
                {mainData[1].details &&
                    mainData[1].details.map((main, key) => {
                        return (
                            <div
                                className={`row  mb-5 mx-5 ${main.class}`}
                                key={key}
                            >
                                <div className="col-xl-12 col-lg-12 mx-auto ">
                                    <div className="title-section title-section mb-5">
                                        <h4
                                            className={`font-weight-bold ${
                                                mainData[0].color ===
                                                "g-background-color"
                                                    ? "b-color "
                                                    : "g-color "
                                            }`}
                                        >
                                            <b>{main.title}</b>
                                        </h4>
                                        <p className="">{main.info}</p>
                                    </div>
                                </div>

                                {main.images &&
                                    main.images.map((level1, key) => {
                                        return (
                                            <div
                                                className="col-md-3 col-6 mb-7 "
                                                key={key}
                                            >
                                                <div className="fanfact text-md-left text-center">
                                                    <img
                                                        className="radius-box"
                                                        src={
                                                            process.env
                                                                .PUBLIC_URL +
                                                            level1
                                                        }
                                                        alt="images"
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

LifeAtNeoContainer.propTypes = {
    mainData: PropTypes.array,
    contRef: PropTypes.any,
};

export default LifeAtNeoContainer;
